import { render, staticRenderFns } from "./OrderHistoryDialog.vue?vue&type=template&id=5997ec50&scoped=true&"
import script from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryDialog.vue?vue&type=style&index=0&id=5997ec50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997ec50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VDialog,VIcon,VSpacer})
